/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { CourseRegistrationManagementPoloHistoryItemViewModel } from "../types/CourseRegistrationManagementPoloHistoryItemViewModel.ts";
import { eActionTypeSchema } from "./eActionTypeSchema.ts";

export const courseRegistrationManagementPoloHistoryItemViewModelSchema =
  z.object({
    oldPoloName: z
      .string()
      .describe("Nome do polo anterior à alteração. Opcional.")
      .nullish(),
    newPoloName: z
      .string()
      .describe("Nome do polo após a alteração. Opcional.")
      .nullish(),
    actionType: z.optional(
      z
        .lazy(() => eActionTypeSchema)
        .describe(
          "0 = Unknown | 1 = Insert | 2 = Update | 3 = Delete | 4 = Search | 5 = Sync | 6 = Integration | 7 = Enrollment | ",
        ),
    ),
    dateLog: z.optional(
      z
        .string()
        .datetime()
        .describe("Data em que a alteração de polo foi registrada."),
    ),
    executedBy: z
      .string()
      .describe("Nome do usuário que executou a alteração de polo.")
      .nullish(),
  }) as unknown as ToZod<CourseRegistrationManagementPoloHistoryItemViewModel>;
